"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataPair = exports.DATA_PAIR_STYLE_TYPE = exports.DATA_PAIR_MARGIN_BOTTOM = exports.DATA_PAIR_LABEL_WIDTH = exports.DATA_PAIR_DIRECTION = exports.DATA_PAIR_BREAKPOINT = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCase = require("upper-case");
var _upperCaseFirst = require("upper-case-first");
require("./DataPair.scss");
var DATA_PAIR_BREAKPOINT = /*#__PURE__*/function (DATA_PAIR_BREAKPOINT) {
  DATA_PAIR_BREAKPOINT["none"] = "none";
  DATA_PAIR_BREAKPOINT["xs"] = "xs";
  DATA_PAIR_BREAKPOINT["sm"] = "sm";
  DATA_PAIR_BREAKPOINT["md"] = "md";
  DATA_PAIR_BREAKPOINT["lg"] = "lg";
  DATA_PAIR_BREAKPOINT["xl"] = "xl";
  return DATA_PAIR_BREAKPOINT;
}(DATA_PAIR_BREAKPOINT || {});
exports.DATA_PAIR_BREAKPOINT = DATA_PAIR_BREAKPOINT;
var DATA_PAIR_DIRECTION = /*#__PURE__*/function (DATA_PAIR_DIRECTION) {
  DATA_PAIR_DIRECTION["column"] = "column";
  DATA_PAIR_DIRECTION["row"] = "row";
  return DATA_PAIR_DIRECTION;
}(DATA_PAIR_DIRECTION || {});
exports.DATA_PAIR_DIRECTION = DATA_PAIR_DIRECTION;
var DATA_PAIR_MARGIN_BOTTOM = /*#__PURE__*/function (DATA_PAIR_MARGIN_BOTTOM) {
  DATA_PAIR_MARGIN_BOTTOM["none"] = "none";
  DATA_PAIR_MARGIN_BOTTOM["xsmall"] = "xsmall";
  DATA_PAIR_MARGIN_BOTTOM["small"] = "small";
  DATA_PAIR_MARGIN_BOTTOM["medium"] = "medium";
  DATA_PAIR_MARGIN_BOTTOM["large"] = "large";
  DATA_PAIR_MARGIN_BOTTOM["xlarge"] = "xlarge";
  return DATA_PAIR_MARGIN_BOTTOM;
}(DATA_PAIR_MARGIN_BOTTOM || {});
exports.DATA_PAIR_MARGIN_BOTTOM = DATA_PAIR_MARGIN_BOTTOM;
var DATA_PAIR_STYLE_TYPE = /*#__PURE__*/function (DATA_PAIR_STYLE_TYPE) {
  DATA_PAIR_STYLE_TYPE["default"] = "default";
  DATA_PAIR_STYLE_TYPE["small"] = "small";
  return DATA_PAIR_STYLE_TYPE;
}(DATA_PAIR_STYLE_TYPE || {});
exports.DATA_PAIR_STYLE_TYPE = DATA_PAIR_STYLE_TYPE;
var DATA_PAIR_LABEL_WIDTH = /*#__PURE__*/function (DATA_PAIR_LABEL_WIDTH) {
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width10"] = 10] = "width10";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width15"] = 15] = "width15";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width20"] = 20] = "width20";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width25"] = 25] = "width25";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width30"] = 30] = "width30";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width33"] = 33] = "width33";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width35"] = 35] = "width35";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width40"] = 40] = "width40";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width45"] = 45] = "width45";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width50"] = 50] = "width50";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width55"] = 55] = "width55";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width60"] = 60] = "width60";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width65"] = 65] = "width65";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width66"] = 66] = "width66";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width70"] = 70] = "width70";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width75"] = 75] = "width75";
  return DATA_PAIR_LABEL_WIDTH;
}(DATA_PAIR_LABEL_WIDTH || {});
exports.DATA_PAIR_LABEL_WIDTH = DATA_PAIR_LABEL_WIDTH;
var DataPair = function DataPair(_ref) {
  var _classNames;
  var children = _ref.children,
    className = _ref.className,
    labelClassName = _ref.labelClassName,
    valueClassName = _ref.valueClassName,
    label = _ref.label,
    _ref$breakpoint = _ref.breakpoint,
    breakpoint = _ref$breakpoint === void 0 ? DATA_PAIR_BREAKPOINT.none : _ref$breakpoint,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? DATA_PAIR_DIRECTION.row : _ref$direction,
    _ref$isColonDisplayed = _ref.isColonDisplayed,
    isColonDisplayed = _ref$isColonDisplayed === void 0 ? true : _ref$isColonDisplayed,
    _ref$labelWidth = _ref.labelWidth,
    labelWidth = _ref$labelWidth === void 0 ? DATA_PAIR_LABEL_WIDTH.width50 : _ref$labelWidth,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? DATA_PAIR_MARGIN_BOTTOM.none : _ref$marginBottom,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? DATA_PAIR_STYLE_TYPE["default"] : _ref$styleType;
  var rootClassName = (0, _classnames["default"])('cds-DataPair', (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "cds-DataPair--".concat((0, _upperCaseFirst.upperCaseFirst)(direction || '')), direction === DATA_PAIR_DIRECTION.row), (0, _defineProperty2["default"])(_classNames, "cds-DataPair--MobileBreakpoint".concat((0, _upperCase.upperCase)(breakpoint || '') || ''), breakpoint !== DATA_PAIR_BREAKPOINT.none), (0, _defineProperty2["default"])(_classNames, "cds-DataPair--Margin".concat((0, _upperCaseFirst.upperCaseFirst)(marginBottom || '') || ''), marginBottom !== DATA_PAIR_MARGIN_BOTTOM.none), (0, _defineProperty2["default"])(_classNames, "cds-DataPair--".concat((0, _upperCaseFirst.upperCaseFirst)(styleType || '') || ''), styleType !== DATA_PAIR_STYLE_TYPE["default"]), (0, _defineProperty2["default"])(_classNames, "cds-DataPair--LabelWidth".concat(labelWidth), labelWidth !== DATA_PAIR_LABEL_WIDTH.width50), _classNames), className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('cds-DataPair-Label', labelClassName)
  }, label, isColonDisplayed && ':'), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('cds-DataPair-Value', valueClassName)
  }, children));
};
exports.DataPair = DataPair;
DataPair.config = {
  breakpoint: DATA_PAIR_BREAKPOINT,
  direction: DATA_PAIR_DIRECTION,
  labelWidth: DATA_PAIR_LABEL_WIDTH,
  marginBottom: DATA_PAIR_MARGIN_BOTTOM,
  styleType: DATA_PAIR_STYLE_TYPE
};